import { render, staticRenderFns } from "./xinZengRenShu.vue?vue&type=template&id=262e3d1a&scoped=true&"
import script from "./xinZengRenShu.vue?vue&type=script&lang=js&"
export * from "./xinZengRenShu.vue?vue&type=script&lang=js&"
import style0 from "./xinZengRenShu.vue?vue&type=style&index=0&id=262e3d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262e3d1a",
  null
  
)

export default component.exports